
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as ZmlyZWJhc2UvYW5hbHl0aWNz from 'firebase/analytics';
import * as ZmlyZWJhc2UvYXBw from 'firebase/app';
import * as ZmlyZWJhc2UvYXV0aA from 'firebase/auth';
import * as ZmlyZWJhc2UvZmlyZXN0b3Jl from 'firebase/firestore';
import * as d2FzbTpqcy1zdHJpbmc from './FootballPool-composeApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_ = ZmlyZWJhc2UvYW5hbHl0aWNz;
const _ref_ZmlyZWJhc2UvYXBw_ = ZmlyZWJhc2UvYXBw;
const _ref_ZmlyZWJhc2UvYXV0aA_ = ZmlyZWJhc2UvYXV0aA;
const _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_ = ZmlyZWJhc2UvZmlyZXN0b3Jl;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
    'kotlin.js.JsArray_$external_class_get' : () => Array,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.Promise_$external_fun' : (p0) => new Promise(p0),
    'kotlin.js.__callJsClosure_((Js?)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((((Js?)->Unit),((Js)->Unit))->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((((Js?)->Unit),((Js)->Unit))->Unit)'](f, p0, p1)),
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.promiseSetDeferred' : (promise, deferred) => promise.deferred = deferred,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.querySelector_$external_fun' : (_this, p0) => _this.querySelector(p0),
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
    'org.w3c.dom.Node_$external_class_get' : () => Node,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
    'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
    'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
    'org.w3c.dom.Touch_$external_class_get' : () => Touch,
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
    'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
    'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
    'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
    'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
    'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'dev.gitlive.firebase.externals.jsObject' : () => ({}),
    'dev.gitlive.firebase.externals.jsSet' : (target, key, value) => { target[key] = value },
    'dev.gitlive.firebase.externals.jsObjectKeys' : (target) => Object.keys(target),
    'dev.gitlive.firebase.externals.jsGet' : (target, key) => target[key],
    'dev.gitlive.firebase.externals.jsObjectEntries' : (target) => Object.entries(target),
    'dev.gitlive.firebase.externals.jsonStringify' : (value) => JSON.stringify(value),
    'dev.gitlive.firebase.externals.jsAnyAsString' : (value) => value,
    'dev.gitlive.firebase.externals.jsTypeOf' : (value) => typeof value,
    'dev.gitlive.firebase.externals.jsAnyAsDouble' : (value) => value,
    'dev.gitlive.firebase.externals.jsAnyAsBoolean' : (value) => value,
    'dev.gitlive.firebase.externals.jsErrorCode' : (error) => error.code,
    'dev.gitlive.firebase.externals.jsIsArray' : (value) => Array.isArray(value),
    'dev.gitlive.firebase.externals.jsonParse' : (value) => JSON.parse(value),
    'dev.gitlive.firebase.externals.jsContainsValue' : (target, key) => target[key] != undefined,
    'dev.gitlive.firebase.externals.initializeApp_$external_fun' : (p0, p1, isDefault0) => _ref_ZmlyZWJhc2UvYXBw_.initializeApp(p0, isDefault0 ? undefined : p1, ),
    'dev.gitlive.firebase.externals.getApp_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2UvYXBw_.getApp(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.auth.externals.uid_$external_prop_getter' : (_this) => _this.uid,
    'dev.gitlive.firebase.auth.externals.user_$external_prop_getter' : (_this) => _this.user,
    'dev.gitlive.firebase.auth.externals.currentUser_$external_prop_getter' : (_this) => _this.currentUser,
    'dev.gitlive.firebase.auth.externals.signInAnonymously_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYXV0aA_.signInAnonymously(p0),
    'dev.gitlive.firebase.auth.externals.getAuth_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2UvYXV0aA_.getAuth(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.firestore.externals.id_$external_prop_getter' : (_this) => _this.id,
    'dev.gitlive.firebase.firestore.externals.path_$external_prop_getter' : (_this) => _this.path,
    'dev.gitlive.firebase.firestore.externals.DocumentReference_$external_class_instanceof' : (x) => x instanceof _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.DocumentReference,
    'dev.gitlive.firebase.firestore.externals.hasPendingWrites_$external_prop_getter' : (_this) => _this.hasPendingWrites,
    'dev.gitlive.firebase.firestore.externals.fromCache_$external_prop_getter' : (_this) => _this.fromCache,
    'dev.gitlive.firebase.firestore.externals.docs_$external_prop_getter' : (_this) => _this.docs,
    'dev.gitlive.firebase.firestore.externals.metadata_$external_prop_getter' : (_this) => _this.metadata,
    'dev.gitlive.firebase.firestore.externals.id_$external_prop_getter_1' : (_this) => _this.id,
    'dev.gitlive.firebase.firestore.externals.ref_$external_prop_getter' : (_this) => _this.ref,
    'dev.gitlive.firebase.firestore.externals.metadata_$external_prop_getter_1' : (_this) => _this.metadata,
    'dev.gitlive.firebase.firestore.externals.data_$external_fun' : (_this, p0, isDefault0) => _this.data(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.firestore.externals.exists_$external_fun' : (_this, ) => _this.exists(),
    'dev.gitlive.firebase.firestore.externals.persistentLocalCache_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.persistentLocalCache(p0),
    'dev.gitlive.firebase.firestore.externals.memoryEagerGarbageCollector_$external_fun' : () => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.memoryEagerGarbageCollector(),
    'dev.gitlive.firebase.firestore.externals.memoryLruGarbageCollector_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.memoryLruGarbageCollector(isDefault0 ? undefined : p0, ),
    'dev.gitlive.firebase.firestore.externals.memoryLocalCache_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.memoryLocalCache(p0),
    'dev.gitlive.firebase.firestore.externals.commit_$external_fun' : (_this, ) => _this.commit(),
    'dev.gitlive.firebase.firestore.externals.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'dev.gitlive.firebase.firestore.externals.set_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.set(p0, p1, isDefault0 ? undefined : p2, ),
    'dev.gitlive.firebase.firestore.externals.get_$external_fun' : (_this, p0) => _this.get(p0),
    'dev.gitlive.firebase.firestore.externals.set_$external_fun_1' : (_this, p0, p1, p2, isDefault0) => _this.set(p0, p1, isDefault0 ? undefined : p2, ),
    'dev.gitlive.firebase.firestore.externals.delete_$external_fun_1' : (_this, p0) => _this.delete(p0),
    'dev.gitlive.firebase.firestore.externals.initializeFirestore_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.initializeFirestore(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'dev.gitlive.firebase.firestore.externals.connectFirestoreEmulator_$external_fun' : (p0, p1, p2, p3, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.connectFirestoreEmulator(p0, p1, p2, isDefault0 ? undefined : p3, ),
    'dev.gitlive.firebase.firestore.externals.getFirestore_$external_fun' : (p0, p1, isDefault0, isDefault1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getFirestore(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'dev.gitlive.firebase.firestore.externals.collection_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.collection(p0, p1),
    'dev.gitlive.firebase.firestore.externals.writeBatch_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.writeBatch(p0),
    'dev.gitlive.firebase.firestore.externals.runTransaction_$external_fun' : (p0, p1, p2, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.runTransaction(p0, p1, isDefault0 ? undefined : p2, ),
    'dev.gitlive.firebase.firestore.externals.__convertKotlinClosureToJsClosure_((Js)->Js)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js)'](f, p0)),
    'dev.gitlive.firebase.firestore.externals.collection_$external_fun_1' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.collection(p0, p1),
    'dev.gitlive.firebase.firestore.externals.onSnapshot_$external_fun' : (p0, p1, p2, p3) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.onSnapshot(p0, p1, p2, p3),
    'dev.gitlive.firebase.firestore.externals.setDoc_$external_fun' : (p0, p1, p2, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.setDoc(p0, p1, isDefault0 ? undefined : p2, ),
    'dev.gitlive.firebase.firestore.externals.refEqual_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.refEqual(p0, p1),
    'dev.gitlive.firebase.firestore.externals.getDoc_$external_fun' : (p0, p1, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDoc(p0, isDefault0 ? undefined : p1, ),
    'dev.gitlive.firebase.firestore.externals.getDocFromCache_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocFromCache(p0),
    'dev.gitlive.firebase.firestore.externals.getDocFromServer_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocFromServer(p0),
    'dev.gitlive.firebase.firestore.externals.doc_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.doc(p0, p1),
    'dev.gitlive.firebase.firestore.externals.onSnapshot_$external_fun_1' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.onSnapshot(p0, p1, p2),
    'dev.gitlive.firebase.firestore.externals.getDocs_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocs(p0),
    'dev.gitlive.firebase.firestore.externals.getDocsFromCache_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocsFromCache(p0),
    'dev.gitlive.firebase.firestore.externals.getDocsFromServer_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocsFromServer(p0),
    'dev.gitlive.firebase.analytics.externals.logEvent_$external_fun' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.logEvent(p0, p1, p2),
    'dev.gitlive.firebase.analytics.externals.setAnalyticsCollectionEnabled_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.setAnalyticsCollectionEnabled(p0, p1),
    'dev.gitlive.firebase.analytics.externals.setConsent_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.setConsent(p0),
    'dev.gitlive.firebase.analytics.externals.getAnalytics_$external_fun' : (p0, isDefault0) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.getAnalytics(isDefault0 ? undefined : p0, ),
    'com.prism.footballsquares.data.emitLocalFirestoreReadTrace' : (message) => { console.info(message) },
    'com.prism.footballsquares.platform.shareInBrowser' : (title, text, onResult) => {
            const copyToClipboard = () => {
                if (!navigator.clipboard || typeof navigator.clipboard.writeText !== "function") {
                    onResult("failed", "Sharing and clipboard access are unavailable in this browser.");
                    return;
                }
                navigator.clipboard.writeText(text).then(
                    () => onResult("copied", ""),
                    error => onResult(
                        "failed",
                        error?.message || "Clipboard access was blocked. Try opening the site over HTTPS."
                    )
                );
            };

            if (typeof navigator.share !== "function") {
                copyToClipboard();
                return;
            }

            try {
                navigator.share({ title, text }).then(
                    () => onResult("shared", ""),
                    error => {
                        if (error?.name === "AbortError") {
                            onResult("cancelled", "");
                        } else {
                            copyToClipboard();
                        }
                    }
                );
            } catch (error) {
                copyToClipboard();
            }
        },
    'com.prism.footballsquares.platform.__convertKotlinClosureToJsClosure_((String,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((String,String)->Unit)'](f, p0, p1)),
    'com.prism.footballsquares.platform.copyInBrowser' : (text, onResult) => {
            if (!navigator.clipboard || typeof navigator.clipboard.writeText !== "function") {
                onResult("failed", "Clipboard access is unavailable. Try opening the site over HTTPS.");
                return;
            }
            try {
                navigator.clipboard.writeText(text).then(
                    () => onResult("copied", ""),
                    error => onResult(
                        "failed",
                        error?.message || "Clipboard access was blocked. Try opening the site over HTTPS."
                    )
                );
            } catch (error) {
                onResult(
                    "failed",
                    error?.message || "Clipboard access was blocked. Try opening the site over HTTPS."
                );
            }
        }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    